import { useMutation } from "@/compat/reactQuery";
import riskAssessmentAttachmentService from "../../services/riskAssessmentAttachmentService";

const useDeleteRiskAssessmentAttachment = () =>
    useMutation(riskAssessmentAttachmentService.deleteAttachment);

export default useDeleteRiskAssessmentAttachment;
